<template>
    <button class="btn" v-bind:class="className" :type="submit ? 'submit' : 'button'" :disabled="loading || disabled" v-on:click.stop="handler">
        <span v-if="loading">
            {{langNettipyoraButton.loading[locale]}} <font-awesome-icon icon="circle-notch" :spin="true"/>
        </span>
        <span v-else>{{text}}</span>  
    </button>
</template>

<script>
import { mapState } from 'vuex';
import langNettipyoraButton from '@/store/lang/nettipyoraButton';

export default {
    name: "NepttipyoraButton",
    props: {
        text: {
            type: String,
            default: 'Button'
        },
        className: String,
        loading: {
            type: Boolean,
            default: false
        },
        clickHandler: {
            type: Function
        },
        submit: Boolean,
        disabled: Boolean
    },
    computed: mapState({
        locale: state => state.locale
    }),
    data() {
        return {
            langNettipyoraButton
        }
    },
    methods: {
        handler() {
            if(this.clickHandler) this.clickHandler();
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
